import React, {useState, useEffect} from 'react';
import {AutoCompleteWidgetChoose} from '../../autocomplete/select/auto-complete-widget-choose';
import {AutoCompletePessoasSelect} from './auto-complete-pessoas-select';
import { PessoaSelecionada } from './pessoa-selecionada';


const AutoCompletePessoasWidget = ({
                                    searchListener,
                                    onChange, 
                                    getApi, 
                                    onSelect, 
                                    autoCompleteProps,
                                    inputProps, 
                                    tipoPessoa = '', 
                                    comBotaoAdicionar=true, 
                                    exibeLabelTipoPessoa=false,
                                    onAfterSave=(evt)=>{},
                                    value=""} ) => {
    
    const [selectedItem, setSelectedItem] = useState("");
    
    const [dados, setDados] = useState([]);

    useEffect(()=> {
        setTimeout(()=> {
            if("string" == (typeof value) && value){
                if(dados && dados[tipoPessoa] && dados[tipoPessoa].length){
                    console.table([{
                        tipoPessoa, value
                    }])
                    const dadosEncontrados = dados[tipoPessoa].filter(dado => {
                        return dado.uuid == value
                    })
                    if(dadosEncontrados.length){
                        setSelectedItem(dadosEncontrados[0]);
                    }
                }
    
            } else {
                setSelectedItem(value);
            }
        })
    }, [value, dados])
    // useEffect(() => {
    //     onChangeEventEmitters.forEach( evtEmitterFunc => {
    //         evtEmitterFunc.register(setSelectedItem);
    //     }) 
    // })

    // useEffect(()=>{
        
    //     if(value){
    //         setSelectedItem(value);
    //     } else{
    //         setSelectedItem("");
    //     }
        
    // }, [value]) 

    // useEffect(()=>{
    //     if(loggedInUserOptions.autoFill){
            
    //         defineLoggedInUserAsSelected();
    //     }
    // }, [loggedInUserOptions.autoFill]);

    // const defineLoggedInUserAsSelected = async () => {
    //     const pessoa = await loggedInUserOptions.getLoggedInUser();
    //     onSelectHandle(pessoa);
    // }

    const onSelectHandle = (value) => {
        setSelectedItem(value);
        onSelect && onSelect(value);
        onChange && onChange(value);
    }


    if(!searchListener) {
        searchListener = (dados)=> {
            setDados(dados);
        }
    }
    //autoComplete.props.onSelect = onSelectHandle;

    

    return <AutoCompleteWidgetChoose
        autoComplete={
            <AutoCompletePessoasSelect
                getApi={getApi}
                searchListener={searchListener}
                onSelect={onSelectHandle}
                tipoPessoa={tipoPessoa}
                comBotaoAdicionar={comBotaoAdicionar}
                autoCompleteProps={autoCompleteProps}
                inputProps={inputProps}
                onAfterSave={onAfterSave}
            ></AutoCompletePessoasSelect> 
        }
        onSelect={onSelectHandle}
        selectedItem={selectedItem}
        selectedTemplate={
            <PessoaSelecionada pessoa={selectedItem} exibeTipoPessoa={exibeLabelTipoPessoa}></PessoaSelecionada>
        }
    ></AutoCompleteWidgetChoose>
}


export { AutoCompletePessoasWidget }